export interface EdgelessLineGridPalette {
  readonly cell: string;
  readonly block: string;
  readonly sector: string;
}

// Separate line-grid tokens keep existing dot/cross colors unchanged.
export const edgelessCanvasLineGridColorVars = {
  cell: '--streamlain-edgeless-canvas-grid-cell-color',
  block: '--streamlain-edgeless-canvas-grid-block-color',
  sector: '--streamlain-edgeless-canvas-grid-sector-color',
} as const;

// CodeCanvas's per-layer palettes, paired with StreamLain's canvas presets.
export const edgelessCanvasLineGridPalettes = {
  light: { cell: '#d2c19a', block: '#d2c19a', sector: '#d2c19a' },
  dark: { cell: '#32372e', block: '#3d4537', sector: '#4c5743' },
  'blue-white': { cell: '#2b486b', block: '#385a81', sector: '#4a739b' },
} as const satisfies Record<string, EdgelessLineGridPalette>;

export function edgelessLineGridPaletteStyle(
  preset: keyof typeof edgelessCanvasLineGridPalettes
) {
  const palette = edgelessCanvasLineGridPalettes[preset];
  return (
    Object.keys(edgelessCanvasLineGridColorVars) as Array<
      keyof EdgelessLineGridPalette
    >
  )
    .map(
      level => `${edgelessCanvasLineGridColorVars[level]}: ${palette[level]};`
    )
    .join('\n');
}
